<script lang="ts">
  import { createEventDispatcher, getContext, onMount, onDestroy, tick } from 'svelte';

  import type { TreatmentMap } from '@config';

  import { splitIo } from '@stores';
  import { Split, Treatment, PaymentProviders } from '@config';
  import { getDefaultPaymentMethod } from '@api'

  import StripePaymentEdit from './StripePaymentEdit.svelte'
  import MoneyPlatform from './MoneyPlatform.svelte';
  import { defaultPaymentMethod } from '../store'
  import { profileContextKey } from '../context';

  const profileContext = getContext(profileContextKey);
  const userId = profileContext.getUserId();
  const profile = profileContext.getProfile();

  const defaultPaymentMethodQuery = getDefaultPaymentMethod(userId)
  const dispatch = createEventDispatcher()

  async function handleComplete() {
    defaultPaymentMethodQuery.refetch()
    dispatch('finish')
  }

  async function handleCancel() {
    dispatch('finish')
  }

  let treatments: TreatmentMap;

  $: treatments = splitIo.getTreatments([Split['MoneyPlatformIintegration']]);
  $: isMoneyPlatfromOn = treatments[Split['MoneyPlatformIintegration']] === Treatment['On'];
  $: isStateFarmCustomer = profile.brokers?.companyId === 'STFRM';
  
  $: getPaymentMethod = isMoneyPlatfromOn ? PaymentProviders['MoneyPlatform'] : $defaultPaymentMethod?.provider

  onMount(() => {
    console.log('pauseScreenRecording', !!window.parent)
    window.parent.postMessage('pauseScreenRecording', '*')
  })

  onDestroy(async () => {
    await tick()
    console.log('resumeScreenRecording', !!window.parent)
    window.parent.postMessage('resumeScreenRecording', '*')
  })
</script>

{#if getPaymentMethod === PaymentProviders['MoneyPlatform'] && isStateFarmCustomer}
  <MoneyPlatform on:saved={handleComplete} on:cancel={handleCancel} />
{:else}
  <StripePaymentEdit on:saved={handleComplete} on:cancel={handleCancel} />
{/if}
